import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';

import { HEADER_MOBILE_MEDIA_QUERY } from '../../constants';
import { CATEGORIES_VERSION_MENU_MOBILE_SLIDE } from '../../services/header/constants';

import { toggleMenuMobileSlide } from '../../services/header/actions';

import { getOrderedCategories } from '../../services/category/selector';
import { getMenuVersion } from '../../services/header/selector';

import CategoriesSubNavComponent from './CategoriesSubNavComponent';

import './MobileCategoriesMenuComponent.scss';

class MobileCategoriesMenuComponent extends React.Component {
    componentDidUpdate(prevProps) {
        const { stateOpenMenuMobileSlide, menuMobileVersion } = this.props;

        // Les boutons peuvent être absents du DOM : le menu est monté via
        // MediaQuery, et la slide ouverte en mobile peut se fermer (changement
        // de route) après un passage du navigateur en desktop.
        if (
            !prevProps.stateOpenMenuMobileSlide &&
            stateOpenMenuMobileSlide &&
            menuMobileVersion === CATEGORIES_VERSION_MENU_MOBILE_SLIDE
        ) {
            document.addEventListener('keydown', this.trapFocus, false);
            const closeButton = document.querySelector('#mobile-categories-menu-button-close');
            if (closeButton) {
                closeButton.focus();
            }
        }
        if (
            prevProps.menuMobileVersion === CATEGORIES_VERSION_MENU_MOBILE_SLIDE &&
            prevProps.stateOpenMenuMobileSlide &&
            !stateOpenMenuMobileSlide
        ) {
            document.removeEventListener('keydown', this.trapFocus, false);
            const openButton = document.querySelector('#mobile-categories-menu-button-open');
            if (openButton) {
                openButton.focus();
            }
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.trapFocus, false);
    }

    trapFocus = e => {
        // Escape ferme le menu ; componentDidUpdate rend le focus au burger.
        if (e.key === 'Escape') {
            this.props.toggleMenuMobileSlide(CATEGORIES_VERSION_MENU_MOBILE_SLIDE);
            return;
        }

        const focusableElements = 'button, a, [tabindex]:not([tabindex="-1"])';
        const modal = document.querySelector('#menu-categories-mobile'); // select the modal by it's id

        const firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
        const focusableContent = modal.querySelectorAll(focusableElements);
        const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal
        let isTabPressed = e.key === 'Tab';

        if (!isTabPressed) {
            return;
        }
        if (e.shiftKey) {
            // if shift key pressed for shift + tab combination
            if (document.activeElement === firstFocusableElement) {
                lastFocusableElement.focus(); // add focus for the last focusable element
                e.preventDefault();
            }
        } else {
            // if tab key is pressed
            if (document.activeElement === lastFocusableElement) {
                // if focused has reached to last focusable element then focus first focusable element after pressing tab
                firstFocusableElement.focus(); // add focus for the first focusable element
                e.preventDefault();
            }
        }
    };

    onClickBtMenuMobile = e => {
        e.preventDefault();
        this.props.toggleMenuMobileSlide(CATEGORIES_VERSION_MENU_MOBILE_SLIDE);
    };

    // Ferme le menu au clic sur l'overlay (la zone sombre hors du panneau) :
    // seul un clic directement sur la slide, pas sur son contenu, est pris.
    onClickOverlay = e => {
        if (e.target === e.currentTarget) {
            this.props.toggleMenuMobileSlide(CATEGORIES_VERSION_MENU_MOBILE_SLIDE);
        }
    };

    render() {
        const {
            categories,
            i18n,
            i18nAccessibility,
            stateOpenMenuMobileSlide,
            menuMobileVersion
        } = this.props;
        const isOpen =
            stateOpenMenuMobileSlide &&
            menuMobileVersion === CATEGORIES_VERSION_MENU_MOBILE_SLIDE;
        // Une autre slide (recherche, espace client) est ouverte : on masque le
        // burger, sinon son z-index (7) le laisse visible par-dessus la slide (5).
        const isOtherSlideOpen = stateOpenMenuMobileSlide && !isOpen;

        return (
            <MediaQuery query={HEADER_MOBILE_MEDIA_QUERY}>
                {matches =>
                    matches && (
                        <React.Fragment>
                            <button
                                type="button"
                                id="mobile-categories-menu-button-open"
                                className={`menu-mobile-bt menu-mobile-bt-listener ${
                                    isOpen ? 'open' : 'closed'
                                }${isOtherSlideOpen ? ' menu-mobile-bt-hidden' : ''}`}
                                data-target="menu"
                                onClick={this.onClickBtMenuMobile}>
                                <span />
                                <span className="sr-only">
                                    {isOpen
                                        ? i18nAccessibility.CATEGORIES_MENU_BUTTON_CLOSE
                                        : i18nAccessibility.CATEGORIES_MENU_BUTTON_OPEN}
                                </span>
                            </button>
                            <div
                                id="menu-categories-mobile"
                                className={`menu-categories-mobile menu-mobile-slide ${
                                    isOpen ? 'open' : 'closed'
                                }`}
                                role="dialog"
                                aria-label={i18nAccessibility.MODAL_LABEL_CATEGORIES}
                                aria-modal="true"
                                onClick={this.onClickOverlay}>
                                <div className="menu-mobile-slide-conteneur">
                                    <div className="menu-mobile-slide-titre bold flex-container-h flex-center-alt">
                                        {i18n.ALL_CATEGORIES}
                                        <button
                                            type="button"
                                            id="mobile-categories-menu-button-close"
                                            className={`menu-mobile-bt menu-mobile-bt-listener show-mobonly ${
                                                isOpen ? 'open' : 'closed'
                                            }`}
                                            data-target="menu"
                                            onClick={this.onClickBtMenuMobile}>
                                            <span />
                                            <span className="sr-only">
                                                {i18nAccessibility.CATEGORIES_MENU_BUTTON_CLOSE}
                                            </span>
                                        </button>
                                    </div>
                                    <CategoriesSubNavComponent
                                        categories={categories}
                                        id="sous-menu-rubriques-categories-mobile"
                                        open={isOpen}
                                        ariaLabel={
                                            i18nAccessibility.NAV_SUBMENU_ALL_CATEGORIES_LABEL
                                        }
                                        isAllOffers
                                        disableHover
                                    />
                                </div>
                            </div>
                        </React.Fragment>
                    )
                }
            </MediaQuery>
        );
    }
}

MobileCategoriesMenuComponent.propTypes = {
    categories: PropTypes.array.isRequired,
    i18n: PropTypes.object.isRequired,
    i18nAccessibility: PropTypes.object.isRequired,
    stateOpenMenuMobileSlide: PropTypes.bool.isRequired,
    menuMobileVersion: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
    categories: getOrderedCategories(state),
    i18n: state.i18n.feature.header.menu,
    i18nAccessibility: state.i18n.feature.header.ACCESSIBILITY,
    stateOpenMenuMobileSlide: state.header.stateOpenMenuMobileSlide,
    menuMobileVersion: getMenuVersion(state)
});

const mapDispatchToProps = {
    toggleMenuMobileSlide
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileCategoriesMenuComponent);



// WEBPACK FOOTER //
// ./src/components/header/MobileCategoriesMenuComponent.js